import m1 from './img/m1.jpg';
import m2 from './img/m2.jpg';
import m3 from './img/m2.jpg';
import { getPrice } from '../../../../../../Prices';

const H7C2KEZVIZ = () => {
    const device = {
        title: 'No installation, On the Shelf Camera 4MP 128GB Storage',
        model: 'H7C2K 4MP 128GB',
        modelViewImage: m3,
        image: [m1,m2],
        shortDescription: 'Dual-Lenses,Pan & Tilt, Panoramic View, Smart Color Night Vision,Two-Way Talk, Auto Smart Tracking',
        price:getPrice('EZVIZ_H7C_128GB'),
        group: 'ezviz',
        checkListKeyword: ['Video'],
        infoHeader: "Plug-and-play camera no installation require",
        spec: [
            { row1: 'Model:', row2: 'EZVIZ_H7C_128GB' },
            { row1: 'Brand:', row2: 'EZVIZ' },
            { row1: 'Resolution:', row2: '4MP 2K' },
            { row1: 'Connectivity:', row2: 'Wi-Fi' },
            { row1: 'Color:', row2: 'White' },
            { row1: 'Mounting:', row2: 'On the Shelf, Plug-and-Play' },
            { row1: 'Power Supply:', row2: 'DC 12V' },
            { row1: 'Field of View:', row2: '360° Panoramic View' },
            { row1: 'Audio:', row2: 'Two-Way Audio' },
            { row1: 'Auto-Tracking:', row2: 'AI Human Detection' },
            { row1: 'Night Vision:', row2: 'Yes' },
            { row1: 'Motion Detection:', row2: 'Yes' },
            { row1: 'Dimensions:', row2: '6.0 x 6.0 x 5.0 inches' },
            { row1: 'Weatherproof:', row2: 'No' },
        ],
        info: [
            {
                header: 'Plug-and-Play Indoor Camera',
                text: 'The EZVIZ H7C Indoor Camera delivers powerful 4MP surveillance in a compact, shelf-ready design. No mounting or wiring required—simply place it on any flat surface and start monitoring instantly.',
                section: [
                    { title: "4MP Full HD Video" },
                    { text: "Capture crystal-clear video with 4MP resolution for sharp, detailed footage that helps you identify people and objects easily." },
        
                    { title: "On-Shelf, No-Install Design" },
                    { text: "Designed for effortless use—just place the H7C on a shelf or desk and plug it in. No drilling, mounting, or technical setup required." },
        
                    { title: "360° Panoramic View" },
                    { text: "Monitor an entire room with a wide-angle lens and motorized pan/tilt functionality, reducing blind spots and increasing coverage." },
        
                    { title: "Smart Motion Detection" },
                    { text: "Automatically detects movement and sends alerts to your phone. Customize motion zones and sensitivity to suit your space." },
        
                    { title: "Clear Night Vision" },
                    { text: "Infrared LEDs provide clear visibility in low-light or no-light conditions, ensuring 24/7 protection." },
        
                    { title: "Two-Way Audio" },
                    { text: "Built-in mic and speaker allow you to listen and speak through the camera—ideal for checking on pets or communicating with family." },
        
                    { title: "Wi-Fi Connectivity" },
                    { text: "Connects easily to your Wi-Fi network for real-time access from your smartphone or tablet using the EZVIZ app." }
                ]
            },
        
            {
                header: 'Smart Features for Easy Security',
                text: 'The EZVIZ H7C combines smart features with simplicity, making it ideal for renters, small spaces, and anyone looking for fast setup and effective monitoring.',
                section: [
                    { title: "Instant Alerts" },
                    { text: "Get instant push notifications on your phone when motion is detected—no matter where you are." },
        
                    { title: "No Tools Required" },
                    { text: "Skip the screwdriver. The camera is fully functional right out of the box—just plug in and go." },
        
                    { title: "Remote Monitoring Anywhere" },
                    { text: "Check live video, talk through the camera, and review footage anytime from the EZVIZ mobile app." },
        
                    { title: "Custom Recording Settings" },
                    { text: "Set recording schedules, adjust motion zones, and control alerts with user-friendly settings in the app." },
        
                    { title: "Cloud or Local Storage" },
                    { text: "Choose between secure cloud storage or saving footage locally with a microSD card (128GB included)." },
        
                    { title: "Privacy Mode" },
                    { text: "Activate privacy mode to temporarily disable video and audio recording when needed, ensuring peace of mind at home." }
                ]
            },
        
        ]
    }
    return device;
}
export default H7C2KEZVIZ;
